import { render } from "./Sync.vue?vue&type=template&id=49098e50"
import script from "./Sync.vue?vue&type=script&lang=js"
export * from "./Sync.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__